import React from 'react'
import styles from './index.module.css'
import { timeStringFromSecondsSinceEpoch } from '../../../utils/time_helpers'
import { IconExclamationMark, IconCheck } from '@tabler/icons-react'
import cornerDownRightIconPath from "../../../../../assets/images/scanner/corner-down-right.png"

const ScannedLineItem = (props) => {

    const {
        qr_data,
        device_name,
        created_at,
        prev_scans,
        event_name,
        product_variant_title
    } = props.scan

    const firstScan = prev_scans && [...prev_scans].sort((a, b) => a.created_at - b.created_at)[0]

    return (
        <>
            <div className={styles.scannedLine}>

                <div className={styles.header}>
                    <div className={styles.eventName}>{event_name}</div>
                    {product_variant_title &&
                        <div className={styles.variantTitle}>{product_variant_title}</div>
                    }
                </div>

                <div className={styles.body}>
                    <div className={styles.scan}>
                        <IconExclamationMark size={14} className={styles.warningIcon}/>

                        <div className={styles.code}>
                            {qr_data}
                        </div>

                        <div className={styles.deviceName}>
                            {device_name}
                        </div>

                        <div className={styles.time}>
                            {timeStringFromSecondsSinceEpoch(created_at)}
                        </div>
                    </div>

                    <div className={styles.firstScan}>

                        <label className={styles.firstScannedLabel}>First scanned by</label>

                        <img className={styles.cornerDownRightIcon} src={cornerDownRightIconPath}/>

                        <IconCheck size={14} className={styles.sucessIcon}/>

                        <div className={styles.code}>
                            {firstScan.qr_data}
                        </div>

                        <div className={styles.deviceName}>
                            {firstScan.device_name}
                        </div>

                        <div className={styles.time}>
                            {timeStringFromSecondsSinceEpoch(firstScan.created_at)}
                        </div>

                    </div>
                </div>

            </div>
        </>
    )

}

export default ScannedLineItem
